/* eslint-disable no-console */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { StepsWrapper, Steps } from './styles';
import { Border } from '../../EventDetails/styles';

class StepsHeading extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // eslint-disable-next-line react/no-unused-state
      selectedTabId: 1,
    };
  }

  // --- NEW: Added Article Steps Configuration ---
  stepsArticle = [
    {
      name: 'About Article',
      showArrow: true,
      number: 1,
    },
    {
      name: 'Customize Article',
      showArrow: true,
      number: 2,
    },
    {
      name: 'Article Content',
      showArrow: false,
      number: 3,
    },
  ];

  stepsSurvey = [
    {
      name: 'About The Survey',
      showArrow: true,
      number: 1,
    },
    {
      name: 'Questions to Ask',
      showArrow: false,
      number: 2,
    },
    {
      name: 'Launch a Survey',
      showArrow: false,
      number: 3,
    },
  ];

  stepsHeadingQuiz = [
    {
      name: 'About Quiz',
      showArrow: true,
      number: 1,
    },
    {
      name: 'Customize Quiz',
      showArrow: true,
      number: 2,
    },
    {
      name: 'Invite Users',
      showArrow: true,
      number: 3,
    },
    {
      name: 'Launch Quiz',
      showArrow: false,
      number: 4,
    },
  ];

  stepsHeadingEvent = [
    {
      name: 'About Event',
      showArrow: true,
      number: 1,
    },
    {
      name: 'Customize Event',
      showArrow: true,
      number: 2,
    },
    {
      name: 'Invite User',
      showArrow: true,
      number: 3,
    },
    {
      name: 'Launch Event',
      showArrow: true,
      number: 4,
    },
    {
      name: 'Email notification',
      showArrow: false,
      number: 5,
    },
  ];

  stepsHeadingOndemand = [
    {
      name: 'About Event',
      showArrow: true,
      number: 1,
    },
    {
      name: 'Customize Event',
      showArrow: false,
      number: 2,
    },
  ];

  

  stepsFitnessExercise = [
    {
      name: 'About The Exercise',
      showArrow: true,
      number: 1,
    },
    {
      name: 'Set Exercise Focus area and age Groups',
      showArrow: false,
      number: 2,
    },
  ];

  stepsFitnessWorkout = [
    {
      name: 'About The Workout',
      showArrow: true,
      number: 1,
    },
    {
      name: 'Add Exercise',
      showArrow: false,
      number: 2,
    },
  ];
  

  stepsCreateRecipe = [
    {
      name: 'About Recipe',
      showArrow: true,
      number: 1
    },
    {
      name: 'Customize Recipe',
      showArrow: true,
      number: 2
    },
    {
      name: 'Time & Servings',
      showArrow: true,
      number: 3
    },
    {
      name: 'Preparation Details',
      showArrow: false,
      number: 4
    }
  ];

  stepsLaunchCompanyInitiative = [
    {
      name: 'About Initiative',
      showArrow: true,
      number: 1,
    },
    {
      name: 'Customize Initiative',
      showArrow: true,
      number: 2,
    },
    {
      name: 'Invite Users',
      showArrow: true,
      number: 3,
    },
    {
      name: 'Launch Initiative',
      showArrow: true,
      number: 4,
    },
    {
      name: 'Email notification',
      showArrow: false,
      number: 5,
    },
  ];

  stepsHeadingHealthProgram = [
    {
      name: 'About Program',
      showArrow: true,
      number: 1,
    },
    {
      name: 'Create Program',
      showArrow: false,
      number: 2,
    },
  ];

  surveyLibrary = [
    {
      name: 'About Survey',
      showArrow: true,
      number: 1,
    },
    {
      name: 'Customize Survey',
      showArrow: false,
      number: 2,
    },
  ];

  stepsSurveyFull = [
    {
      name: 'About Survey',
      showArrow: true,
      number: 1,
    },
    {
      name: 'Customize Survey',
      showArrow: true,
      number: 2,
    },
    {
      name: 'Invite Users',
      showArrow: true,
      number: 3,
    },
    {
      name: 'Launch Survey',
      showArrow: false,
      number: 4,
    },
  ];

  stepsHeadingCoreValue = [
    {
      name: 'About Core Value',
      showArrow: true,
      number: 1,
    },
    {
      name: 'Customize Core Value',
      showArrow: false,
      number: 2,
    },
  ];

  stepsHeadingCreateCoreValue = [
    {
      name: 'About Core Value',
      showArrow: true,
      number: 1,
    },
    {
      name: 'Customize Core Value',
      showArrow: false,
      number: 2,
    },
  ];

  stepsHeadingCreateHDMInitiative = [
    {
      name: 'About initiative',
      showArrow: true,
      number: 1,
    },
    {
      name: 'Customize initiative',
      showArrow: false,
      number: 2,
    },
  ];

  stepsCreateWellnessChallenge = [
    {
      name: 'Create Category',
      showArrow: true,
      number: 1,
    },
    {
      name: 'Upload Badges',
      showArrow: false,
      number: 2,
    },
  ];

  stepsWellnessChallengeCategory = [
    {
      name: 'About Wellness Challenge',
      showArrow: true,
      number: 1,
    },
    {
      name: 'Customize Challenge',
      showArrow: true,
      number: 2,
    },
    {
      name: 'Challenge Goal',
      showArrow: true,
      number: 3,
    },
    {
      name: 'Pre-Join Quiz',
      showArrow: true,
      number: 4,
    },
    {
      name: 'Feedback Quiz',
      showArrow: false,
      number: 5,
    },
  ];

  stepsHeadingChallenge = [
    {
      name: 'About Challenge',
      showArrow: true,
      number: 1,
    },
    {
      name: 'Customize Challenge',
      showArrow: true,
      number: 2,
    },
    {
      name: 'Invite User',
      showArrow: true,
      number: 3,
    },
    {
      name: 'Launch Challenge',
      showArrow: true,
      number: 4,
    },
    {
      name: 'Email notification',
      showArrow: false,
      number: 5,
    },
  ];

  stepsHeadingCreateChallenge = [
    {
      name: 'About Challenge',
      showArrow: true,
      number: 1,
    },
    {
      name: 'Customize Challenge',
      showArrow: true,
      number: 2,
    },
    {
      name: 'Create Challenge',
      showArrow: false,
      number: 3,
    },
  ];


  stepsForAffirmation = [
    {
      name: 'Customize Affirmations',
      showArrow: true,
      number: 1,
    },
    {
      name: 'Daily Affirmations',
      showArrow: false,
      number: 2,
    },
  ];

  stepsHeadingChallengeEdit = [
    {
      name: 'About Challenge',
      showArrow: true,
      number: 1,
    },
    {
      name: 'Customize Challenge',
      showArrow: true,
      number: 2,
    },
    {
      name: 'Edit Challenge',
      showArrow: false,
      number: 3,
    },
  ];

  articleQuiz = [
    {
      name: 'Quiz Questions',
      showArrow: false,
      number: 1,
    },
  ]
  getHeading = () => {
    const { type } = this.props;

    switch (type) {
    case 'article':
      return this.stepsArticle; // Returns the 3-step article array
    case 'challengeLibraryEdit':
      return this.stepsHeadingChallengeEdit;
    case 'challengeCreate':
      return this.stepsHeadingCreateChallenge;
    case 'challenge':
      return this.stepsHeadingChallenge;
    case 'quiz':
      return this.stepsHeadingQuiz;
    case 'create-core-value':
      return this.stepsHeadingCreateCoreValue;
    case 'create-hdm-initiative':
      return this.stepsHeadingCreateHDMInitiative;
    case 'core-value':
      return this.stepsHeadingCoreValue;
    case 'event':
      return this.stepsHeadingEvent;
    case 'exercise':
      return this.stepsFitnessExercise;
    case 'workout':
      return this.stepsFitnessWorkout;
    case 'initiative':
      return this.stepsLaunchCompanyInitiative;
    case 'health-program':
      return this.stepsHeadingHealthProgram;
    case 'survey-library':
      return this.surveyLibrary;
    case 'survey':
      return this.stepsSurveyFull;
    case 'create-recipe':
      return this.stepsCreateRecipe;
    case 'wellness-challenge':
      return this.stepsCreateWellnessChallenge;
    case 'wellness-challenge-category':
      return this.stepsWellnessChallengeCategory;
    case 'Create-affirmations':
      return this.stepsForAffirmation;
    case 'create-coach':
      return [
        {
          name: 'About Coach',
          showArrow: true,
          number: 1,
        },
        {
          name: 'Create Coach',
          showArrow: false,
          number: 2,
        },
      ];
    case 'article-quiz':
      return this.articleQuiz;
    default:
      return this.stepsHeadingOndemand;
    }
  };

  render() {
    const { stepCount } = this.props;
    const heading = this.getHeading();

    return (
      <StepsWrapper>
        {heading.map((step, index) => (
          <Steps
            key={index}
            active={index + 1 === stepCount}
            completed={index + 1 < stepCount}
          >
            <div className="wrapper">
              <div className="number">{step.number}</div>
              <div
                className="heading"
                style={{ color: index + 1 <= stepCount ? '#184A61' : '#BDBDBD' }}
              >
                {this.props.t(step.name)}
              </div>
            </div>
            {step.showArrow && (
              <Border
                style={{
                  border: '1px solid #EFEFEF',
                  margin: '20px 0px',
                  width: '100%',
                }}
              />
            )}
          </Steps>
        ))}
      </StepsWrapper>
    );
  }
}

StepsHeading.propTypes = {
  stepCount: PropTypes.number,
  type: PropTypes.string,
  t: PropTypes.func,
};

export default withTranslation()(StepsHeading);